import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Form, FormGroup, Label, Input } from 'reactstrap'
import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import { withTranslation } from 'react-i18next'

import Select from 'components/common/Select'

import { fetchFilters, addContracts, removeContracts, emptyAllSelection } from 'actions/contractSelection'
import { setFilters } from 'store/searchFilters'

class SearchFilters extends Component {
  UNSAFE_componentWillMount() {
    this.props.fetchFilters()
  }

  toggleValueOfType = (type, value, shouldAdd) => () => {
    let filtered
    if (shouldAdd) {
      filtered = [...this.props.searchFilters[type]]
      filtered.push(value)
    } else {
      filtered = this.props.searchFilters[type].filter((f) => f !== value)
    }
    const newFilter = { ...this.props.searchFilters }
    newFilter[type] = filtered
    this.props.setFilters(newFilter)
  }

  changeProviders = (e) => {
    this.props.setFilters({
      ...this.props.searchFilters,
      providers: e === null ? [] : e.map((i) => i.value),
    })
  }

  changeCountries = (e) => {
    this.props.setFilters({
      ...this.props.searchFilters,
      countries: e === null ? [] : e.map((i) => i.value),
    })
  }

  changeBusinessUnit = (e) => {
    this.props.setFilters({
      ...this.props.searchFilters,
      businessUnit: e === null ? [] : e.map((i) => i.label),
    })
  }

  changeStartYear = (e) => {
    const value = e ? e.value : null
    this.props.setFilters({ ...this.props.searchFilters, startYear: value })
  }

  changeEndYear = (e) => {
    const value = e ? e.value : null
    this.props.setFilters({ ...this.props.searchFilters, endYear: value })
  }

  toggleContracts = (counterIds, shouldAdd) => () => {
    this.props.emptyContracts()
    this.props.addContracts(counterIds)
  }

  render() {
    const currentYear = new Date().getFullYear()
    const availableYears = []
    for (let i = currentYear - 5; i < currentYear + 5; i++) {
      availableYears.push({ value: i, label: i })
    }
    return (
      <Form>
        <Row className="filter-section">
          <Col>
            <Row>
              <Col>
                <Label className="filter-title">
                  {this.props.t('sidebar.searchFilters.energyFilter')}
                </Label>
              </Col>
            </Row>
            <Row>
              <Col xs="3">
                <Label
                  className={`form-check-label${
                    this.props.searchFilters.energyType.includes(1) ? ' checked' : ''
                    }`}
                >
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    onChange={this.toggleValueOfType(
                      'energyType',
                      1,
                      !this.props.searchFilters.energyType.includes(1),
                    )}
                  />
                  {this.props.t('sidebar.searchFilters.gaz')}
                </Label>
              </Col>
              <Col xs="3">
                <Label
                  className={`form-check-label${
                    this.props.searchFilters.energyType.includes(2) ? ' checked' : ''
                    }`}
                >
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    onChange={this.toggleValueOfType(
                      'energyType',
                      2,
                      !this.props.searchFilters.energyType.includes(2),
                    )}
                  />
                  {this.props.t('sidebar.searchFilters.electricity')}
                </Label>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="filter-section">
          <Col xs="8">
            <Row>
              <Col>
                <Label className="filter-title" for="searchBU">
                  {this.props.t('sidebar.searchFilters.businessUnit')}
                </Label>
              </Col>
            </Row>
            <Row>
              <Col>
                <Select
                  isMulti
                  value={this.props.businessUnitsForSelect?.filter((option) =>
                    this.props.searchFilters.businessUnit?.includes(option.label),
                  )}
                  placeholder={this.props.t('sidebar.searchFilters.buFilter')}
                  options={this.props.businessUnitsForSelect}
                  id="valueBusinessUnits"
                  onChange={this.changeBusinessUnit}
                  isClearable={false}
                  width="100%"
                  bordered
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="filter-section">
          <Col>
            <Row>
              <Col>
                <Label className="filter-title">
                  {this.props.t('sidebar.searchFilters.timeframe')}
                </Label>
              </Col>
            </Row>
            <Row className="date-range">
              <Col className="date-range-wrapper">
                <div className="date-range-global">
                  <FormGroup>
                    <Select
                      value={availableYears.find(
                        (option) => option.value === this.props.searchFilters.startYear,
                      )}
                      options={availableYears}
                      onChange={this.changeStartYear}
                      width={100}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Select
                      value={availableYears.find(
                        (option) => option.value === this.props.searchFilters.endYear,
                      )}
                      options={availableYears}
                      onChange={this.changeEndYear}
                      width={100}
                    />
                  </FormGroup>
                </div>
              </Col>
            </Row>

          </Col>
        </Row>

        <Row className="contract-section">
          <Col>
            <ul className="form-radio-list">
              {this.props.countries.map((c) =>
                this.props.contractsByCountryCode[c.code] ? (
                  <li key={c.code}>
                    <Label>
                      {c.libelle}
                    </Label>
                    <ul>
                      {this.props.contractsByCountryCode[c.code].map((ctr) => {
                        const checked = this.props.selectedContracts.includes(ctr.id)
                        return (
                          <li key={ctr.id}>
                            {/* <Label className={`form-check-label${checked ? ' checked' : ''}`}> */}
                            <Input
                              type="radio"
                              onChange={this.toggleContracts([ctr.id], !checked)}
                              checked={checked}
                            />
                            <Label>
                              {ctr.CtrNrjId == 2 ?
                                <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="#00aaff"><path d="m422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z" /></svg>
                                :
                                <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="#008480"><path d="M240-400q0 52 21 98.5t60 81.5q-1-5-1-9v-9q0-32 12-60t35-51l113-111 113 111q23 23 35 51t12 60v9q0 4-1 9 39-35 60-81.5t21-98.5q0-50-18.5-94.5T648-574q-20 13-42 19.5t-45 6.5q-62 0-107.5-41T401-690q-39 33-69 68.5t-50.5 72Q261-513 250.5-475T240-400Zm240 52-57 56q-11 11-17 25t-6 29q0 32 23.5 55t56.5 23q33 0 56.5-23t23.5-55q0-16-6-29.5T537-292l-57-56Zm0-492v132q0 34 23.5 57t57.5 23q18 0 33.5-7.5T622-658l18-22q74 42 117 117t43 163q0 134-93 227T480-80q-134 0-227-93t-93-227q0-129 86.5-245T480-840Z" /></svg>}
                              {ctr.FormattedName}
                            </Label>
                          </li>
                        )
                      })}
                    </ul>
                  </li>
                ) : null,
              )}
            </ul>
          </Col>
        </Row>
      </Form>
    )
  }
}

SearchFilters.propTypes = {
  contracts: PropTypes.array.isRequired,
  countries: PropTypes.array.isRequired,
  countriesForSelect: PropTypes.array.isRequired,
  providersForSelect: PropTypes.array.isRequired,
  fetchFilters: PropTypes.func.isRequired,
  addContracts: PropTypes.func.isRequired,
  removeContracts: PropTypes.func.isRequired,
  emptyContracts: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  countries: state.countries,
  providers: state.providers,
  organisations: state.organisations,
  contracts: state.contracts.contractList,
  selectedContracts: state.contracts.contractSelection,
  searchFilters: state.searchFilters,
})

const mapDispatchToProps = (dispatch) => ({
  fetchFilters: () => {
    dispatch(fetchFilters())
  },
  addContracts: (contracts) => {
    dispatch(addContracts(contracts))
  },
  removeContracts: (contracts) => {
    dispatch(removeContracts(contracts))
  },
  setFilters: (filter) => {
    dispatch(setFilters(filter))
  },
  emptyContracts: () => {
    dispatch(emptyAllSelection())
  }
})

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({ countries, providers, organisations, contracts, selectedContracts, searchFilters }) => ({
    countriesForSelect: countries.map((c) => ({
      value: c.id,
      label: c.libelle,
    })),
    providersForSelect: providers.map((c) => ({
      value: c.id,
      label: c.libelle,
    })),
    businessUnitsForSelect: organisations?.UorEnfants?.map((c) => ({
      value: c.id,
      label: c.UorNom,
    })),
    // Return a map of by country code
    contractsByCountryCode: contracts.reduce((rv, x) => {
      if (
        searchFilters.energyType.includes(x.CtrNrjId) &&
        (searchFilters.providers?.length === 0 ||
          searchFilters.providers.includes(x.CtrIdFournisseur)) &&
        (searchFilters.countries?.length === 0 || searchFilters.countries.includes(x.CtrIdPays)) &&
        (!searchFilters.businessUnit || searchFilters.businessUnit?.length === 0 ||
          searchFilters.businessUnit?.includes(x.BusinessUnitName)) &&
        (!searchFilters.startYear || x.CtrDateFin.split('/')[2] >= searchFilters.startYear) &&
        (!searchFilters.endYear || x.CtrDateDebut.split('/')[2] <= searchFilters.endYear)
      ) {
        ;(rv[x['CtrCodePays']] = rv[x['CtrCodePays']] || []).push(x)
      }
      return rv
    }, {}),
    // Status of a country. 0 for no contract selected, 1 for some, 2 for all
    countryStatus: contracts.reduce((rv, x) => {
      let newValue = 1
      switch (rv[x['CtrCodePays']]) {
        case undefined:
          newValue = selectedContracts.includes(x.id) ? 2 : 0
          break
        case 0:
          newValue = selectedContracts.includes(x.id) ? 1 : 0
          break
        case 2:
          newValue = selectedContracts.includes(x.id) ? 2 : 1
          break
        default:
          break
      }
      rv[x['CtrCodePays']] = newValue
      return rv
    }, {}),
  })),
)(SearchFilters)
